// Centralized form validation function that checks required fields, password match, and password strength
const isAuthFormValid = (isSignIn, signInForm, signUpForm, setErrorMessage) => {
  if (isSignIn) {
    // For sign-in, ensure email and password are filled
    if (!signInForm.email || !signInForm.password) {
      setErrorMessage("Please fill in all required fields");
      return false;
    }
  } else {
    // For sign-up, ensure all fields are filled
    if (!signUpForm.fullName || !signUpForm.occupation || !signUpForm.state || !signUpForm.lga) {
      setErrorMessage("Please fill in all required fields");
      return false;
    }

    // For sign-up, check if passwords match
    if (signUpForm.password !== signUpForm.confirmPassword) {
      setErrorMessage("Passwords do not match");
      return false;
    }

    // Check password strength for both sign-in
    if (signUpForm.password.length < 8) {
      setErrorMessage("Password must be at least 8 characters");
      return false;
    }
  }

  return true;
};

export default isAuthFormValid;
